import { render } from "./SubscribePlanItemHeader.vue?vue&type=template&id=0b88528e&scoped=true"
import script from "./SubscribePlanItemHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribePlanItemHeader.vue?vue&type=script&setup=true&lang=js"

import "./SubscribePlanItemHeader.vue?vue&type=style&index=0&id=0b88528e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b88528e"],['__file',"src/components/Subscribe/SubscribePlanItemHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b88528e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b88528e', __exports__)) {
    api.reload('0b88528e', __exports__)
  }
  
  module.hot.accept("./SubscribePlanItemHeader.vue?vue&type=template&id=0b88528e&scoped=true", () => {
    api.rerender('0b88528e', render)
  })

}


export default __exports__